import React, { useState } from 'react';
import { apiHolder as api, apis } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import styles from './comment.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import { ReactComponent as ConfirmIconDelete } from '@/images/icons/edm/confirm-delete.svg';
import CommentModal from '../../../../common/components/comment/CommentModal';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const Comment = props => {
    const { mailId, memo = '', account } = props;
    const [commentModalVisible, setCommentModalVisible] = useState(false);
    const delComment = e => {
        e.stopPropagation();
        SiriusModal.confirm({
            title: (React.createElement("div", { className: styles.commentDelModal },
                React.createElement(ConfirmIconDelete, null),
                React.createElement("span", { className: styles.commentDelDesc }, "\u786E\u5B9A\u8981\u5220\u9664\u8BE5\u90AE\u4EF6\u7684\u5907\u6CE8\u5417\uFF1F"))),
            icon: null,
            onOk() {
                mailApi
                    .doMarkMail(false, mailId, 'memo', false, true, { memo: '' }, account)
                    .then(() => {
                    message.success(`已成功删除备注`);
                })
                    .catch(() => {
                    message.fail(`删除备注失败`);
                });
            },
            onCancel(e) { },
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(styles.comment), "data-test-id": "mail-comment-panel" },
            React.createElement("div", { className: classnames(styles.desc) },
                React.createElement("span", { className: classnames(styles.icon) },
                    React.createElement(IconCard, { type: "mailComment" })),
                React.createElement("span", { className: classnames(styles.memo), "data-test-id": "mail-comment-panel-content" }, memo)),
            React.createElement("div", { className: classnames(styles.operate) },
                React.createElement("span", { className: classnames(styles.btn, styles.edit), onClick: e => {
                        e.stopPropagation();
                        setCommentModalVisible(true);
                    }, "data-test-id": "mail-comment-panel-edit" }, "\u7F16\u8F91"),
                React.createElement("span", { className: classnames(styles.btn, styles.del), onClick: delComment, "data-test-id": "mail-comment-panel-delete" }, "\u5220\u9664"))),
        commentModalVisible && React.createElement(CommentModal, { visible: commentModalVisible, setVisible: setCommentModalVisible, memo: memo, mailId: mailId, account: account })));
};
export default Comment;
